/*
  •	Copyright (c) 2024 Pegasystems Inc.
  •	All rights reserved.
*/
import createObject from '../../../object/create-object';
import executeObjectWideAction from '../../../object/execute-object-wide-action';
import getObjectById from '../../../object/get-object';
import openObjectAction from '../../../object/get-object-wide-action';
import createExternalObject from '../../../object/create-external-object';
import deleteWork from '../../../object/delete-work';

const objectEpics = [
  createObject,
  getObjectById,
  executeObjectWideAction,
  openObjectAction,
  createExternalObject,
  deleteWork
];

export default objectEpics;
